import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { subscriptionActions } from '../../../redux/slices/subscriptionSlice';
import { Subscription } from '../../../redux/slices/subscriptionSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useUpdateAutoRenew = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const onSuccess = (response: unknown) => {
    const data = (response as SuccessHttpResponse<Subscription>).data;
    dispatch(subscriptionActions.setActiveSubscription(data));
    toast.success('Auto-renew updated successfully');
  };

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error('Error updating auto-renew:', err?.message);
    toast.error(err?.response?.data?.message ?? 'Failed to update auto-renew');
  };

  const updateAutoRenew = (autoRenewEnabled: boolean) => {
    const url: HttpConfig = {
      url: 'auth-service/subscriptions/me/auto-renew',
      method: 'patch',
      data: { autoRenewEnabled },
    };
    return request(url, onSuccess, setLoading, onError);
  };

  return { updateAutoRenew, loading };
};

export default useUpdateAutoRenew;
